module.exports = __webpack_public_path__ + "laughcry.adc4f0a8.png";